import { render } from "./PickList.vue?vue&type=template&id=5066513a"
import script from "./PickList.vue?vue&type=script&lang=js"
export * from "./PickList.vue?vue&type=script&lang=js"

import "./PickList.vue?vue&type=style&index=0&id=5066513a&lang=css"
script.render = render

export default script